import { SET_USER_ROLE } from '../action/types'
const initialState = {
     currentUser: { userId: undefined, role: undefined },
}

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case SET_USER_ROLE:
            return {
                ...state,
                currentUser: action.payload
            }
        default:
            return state
    }
}